import { slicedToArray as _slicedToArray } from './_virtual/_rollupPluginBabelHelpers.esm.js';
import { useRef, useState, useEffect, useCallback } from 'react';

// For explanation of "controlled" and "uncontrolled" concept: https://itnext.io/controlled-and-uncontrolled-component-design-pattern-in-react-21e8d40e46e
function useControlled(_ref) {
  var controlled = _ref.controlled,
    defaultProp = _ref["default"],
    name = _ref.name,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? 'value' : _ref$state;
  var _useRef = useRef(controlled !== undefined),
    isControlled = _useRef.current;
  var _useState = useState(defaultProp),
    _useState2 = _slicedToArray(_useState, 2),
    valueState = _useState2[0],
    setValue = _useState2[1];
  var value = isControlled ? controlled : valueState;
  var valueRef = useRef(value);
  useEffect(function () {
    if (isControlled) {
      valueRef.current = value;
    }
  }, [isControlled, value]);
  // eslint-disable-next-line no-console
  // console.log(
  //   `useControlled controlled: ${controlled} name: ${name} state: ${state} defaultProp: ${JSON.stringify(
  //     defaultProp
  //   )}`
  // )
  if (process.env.NODE_ENV !== 'production') {
    useEffect(function () {
      if (isControlled !== (controlled !== undefined)) {
        console.error(["Tui: a component is changing the ".concat(isControlled ? '' : 'un', "controlled ").concat(state, " state of ").concat(name, " to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', "Decide between using a controlled or uncontrolled ".concat(name, " ") + 'element for the lifetime of the component.', "The nature of the state is determined during the first render, it's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [controlled]);
    var _useRef2 = useRef(defaultProp),
      defaultValue = _useRef2.current;
    useEffect(function () {
      if (defaultValue !== defaultProp) {
        console.error(["Tui: a component is changing the default ".concat(state, " state of an uncontrolled ").concat(name, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(name, ".")].join('\n'));
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(defaultProp)]);
  }
  var setValueIfUncontrolled = useCallback(function (newValue) {
    // eslint-disable-next-line no-console
    // console.log(
    //   `useControlled setValueIfUncontrolled newValue: ${newValue} isControlled: ${isControlled}`
    // )
    if (!isControlled) {
      setValue(newValue);
    }
    valueRef.current = newValue;
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [controlled]);
  return [value, setValueIfUncontrolled, valueRef];
}

export { useControlled as default };
//# sourceMappingURL=use-controlled.esm.js.map
